import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cloneElement, PureComponent } from "react";
import ArrowRightIcon from "static/svg/arrow-right-v2.svg";
import Colors from "styles/colors";
import { StyledTabs } from "./tabs.scss";
import Constants from "../constants";
class Tabs extends PureComponent {
    componentDidMount() {
        const { autoTransition } = this.props;
        if (autoTransition) this.playAutoTransition();
    }
    componentWillUnmount() {
        if (this._changeActiveIndexInterval) clearInterval(this._changeActiveIndexInterval);
    }
    getNextActiveTab(activeTabIndex) {
        const { children } = this.props;
        const currentIndex = activeTabIndex ? activeTabIndex + 1 : 0;
        for(let i = currentIndex; i < children.length + currentIndex; i++){
            const tabIndex = i % children.length;
            const tab = children[i % children.length];
            if (!tab.props.isDisabled) {
                return tabIndex;
            }
        }
    }
    playAutoTransition() {
        const { autoTransition } = this.props;
        this._changeActiveIndexInterval = setInterval(()=>{
            const { activeTabIndex } = this.state;
            this.setState({
                activeTabIndex: this.getNextActiveTab(activeTabIndex)
            });
        }, autoTransition);
    }
    handleTabClick(index) {
        const { children } = this.props;
        if (children[index].props.isDisabled) return;
        if (this._changeActiveIndexInterval) clearInterval(this._changeActiveIndexInterval);
        this.setState({
            activeTabIndex: index
        });
    }
    contentRenderer() {
        const { children } = this.props;
        const { activeTabIndex } = this.state;
        if (children[activeTabIndex]) {
            return children[activeTabIndex].props.children;
        }
    }
    tabsRenderer() {
        const { children } = this.props;
        const { activeTabIndex } = this.state;
        return children.map((child, index)=>{
            return /*#__PURE__*/ cloneElement(child, {
                onClick: this.handleTabClick,
                index,
                isActive: index === activeTabIndex
            });
        });
    }
    renderSelectedTabIndicator() {
        const { activeTabIndex } = this.state;
        const { color } = this.props;
        const top = activeTabIndex * Constants.TAB_HEIGHT;
        const transform = `translateY(${top}px)`;
        return /*#__PURE__*/ _jsx("div", {
            className: "selected-tab-indicator-component",
            style: {
                transform,
                height: Constants.TAB_HEIGHT
            },
            children: /*#__PURE__*/ _jsx("div", {
                className: "selected-tab-indicator",
                style: {
                    backgroundColor: Colors[color]
                },
                children: /*#__PURE__*/ _jsx(ArrowRightIcon, {})
            })
        });
    }
    getContentInlineStyle() {
        const { minHeight, fullBackground, backgroundColor, paddingAboveTabs } = this.props;
        return {
            minHeight,
            background: !fullBackground && Colors[backgroundColor],
            paddingTop: paddingAboveTabs
        };
    }
    getTabsInlineStyle() {
        const { paddingAboveTabs } = this.props;
        return {
            paddingTop: paddingAboveTabs
        };
    }
    render() {
        const { positionStyles, addTabIndicator } = this.props;
        return /*#__PURE__*/ _jsxs(StyledTabs, {
            className: "vertical-tabs",
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "tabs",
                    style: this.getTabsInlineStyle(),
                    children: /*#__PURE__*/ _jsxs("div", {
                        className: "tabs-wrapper",
                        style: positionStyles,
                        children: [
                            this.tabsRenderer(),
                            addTabIndicator && this.renderSelectedTabIndicator()
                        ]
                    })
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "content",
                    role: "tab",
                    style: this.getContentInlineStyle(),
                    children: this.contentRenderer()
                })
            ]
        });
    }
    constructor(props){
        super(props);
        this.state = {
            activeTabIndex: props.defaultActiveTabIndex || this.getNextActiveTab()
        };
        this.handleTabClick = this.handleTabClick.bind(this);
    }
}
export { Tabs as default };
